export default __webpack_public_path__ + "static/media/C0.e4b2da81.mp3";